<template>
  <div class="overall-bg header-top">
    <section>
      <b-row>
        <b-col lg="3" xl="2" xxl="2" class="leftsidebar">
          <LeftBar masterheading="Store Master" :storestatus="true" :listed="sidebardata"></LeftBar>
          <a class="back-btn" @click="$router.back">
            <img alt="Vue logo" class="back" src="../../../../../assets/Img/icons/backtoright.svg" width="125"
              height="125" />
          </a>
        </b-col>
        <b-col lg="9" xl="10" xxl="10" class="other-tabs">
          <div class="sidebar-static-header">
            <p class="light-txt count-shows">SUP9856</p>
            <span class="sidebar-heading">Emergency Supplies</span>
          </div>

          <b-container fluid>
            <b-row>
              <n-tabs default-value="Details" type="line">
                <n-tab-pane name="Details" :tab="$t('Tabs.details')">
                  <b-row>
                    <b-col lg="12" xl="8" xxl="6">
                      <Details />
                    </b-col>
                    <b-col lg="5" xl="4" xxl="3">
                      <quickcreate></quickcreate>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col lg="12" xl="12" xxl="10">
                      <StoreDetails />
                      <MemberDetails status="0" />
                    </b-col>
                  </b-row>
                </n-tab-pane>
                <n-tab-pane name="Items" :tab="$t('Tabs.Items')">
                  <DataTable :datalist="Iitems" :dataheader="iheader" @createclick="" />
                </n-tab-pane>
                <n-tab-pane name="User" :tab="$t('Tabs.User')">
                  <DataTable searchleftValue="Category - Store mapping table" :datalist="items"
                    @detailsclick="handleClick" :dataheader="userheader" @createclick="" />
                </n-tab-pane>
                <n-tab-pane name="Documents" :tab="$t('Tabs.Documents')">
                  <DataTable searchleftValue="Category - Store mapping table" :datalist="items" :dataheader="docheader"
                    @createclick="" />
                </n-tab-pane>
                <n-tab-pane name="Category" :tab="$t('Tabs.ItemCategory')">
                  <DataTable btnname="Link new category" searchleftValue="Category - Store mapping table"
                    :datalist="items" :dataheader="Icategoryheader" @createclick="" />
                </n-tab-pane>
                <n-tab-pane name="Logs" :tab="$t('Tabs.Logs')">
                  <Log></Log>
                  <!-- <DataTable searchleftValue="Showing 125 logs" :datalist="items"
                                        :dataheader="headers" @createclick="" /> -->
                </n-tab-pane>
              </n-tabs>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </section>
  </div>
  <UserDetails :trigger="showpopModal" @close="showpopModal = false" />
  <!-- <Rightsidebar></Rightsidebar> -->
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import LeftBar from "../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import StoreDetails from "../../../../../modules/Inventory/components/MasterDetails/StoreDetails.vue";
import MemberDetails from "../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";
import quickcreate from "../../../../../modules/Inventory/components/MasterDetails/quickcreate.vue";

// import DataTable from '../../../../components/FormComponents/Table.vue'
// import Rightsidebar from '../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsSidebar.vue'
import UserDetails from "../../../../../modules/Inventory/components/Sidebar/RightSidebar/UserDetailsRightSidebar.vue";

import Log from "../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
export default defineComponent({
  components: {
    LeftBar,
    Details,
    StoreDetails,
    MemberDetails,
    quickcreate,
    UserDetails,
    // Rightsidebar,
    Log,
  },
  setup() {
    const iheader = [
      { text: "Items#", value: "items" },
      { text: "HSN#", value: "team" },
      { text: "Name", value: "number" },
      { text: "Avg Landing Cost", value: "position" },
      { text: "Tax", value: "height" },
      { text: "MRP", value: "weight", sortable: true },
      { text: "Margins", value: "lastAttended" },
      { text: "Quantity", value: "country" },
      { text: "Rack", value: "country" },
      { text: "Box", value: "country" },
      { text: "Quantity Value", value: "country" },
      { text: "Supplier#", value: "country" },
      { text: "Similar Generic #", value: "country" },
    ];
    const userheader = [
      { text: "Id#", value: "items" },
      { text: "Name", value: "team" },
      { text: "Role", value: "number" },
      { text: "Phone No.", value: "position" },
      { text: "Email", value: "height" },
      { text: "Last Active", value: "weight", sortable: true },
    ];
    const docheader = [
      { text: "File Name", value: "items" },
      { text: "Category", value: "team" },
      { text: "Size", value: "number" },
      { text: "Date Uploaded", value: "position" },
      { text: "Uploaded by", value: "height" },
    ];
    const Icategoryheader = [
      { text: "Item Category Code", value: "items" },
      { text: "Category Name", value: "team" },
      { text: "#items", value: "number" },
      { text: "Total Value", value: "position" },
    ];
    const Iitems = [
      {
        player: "Stephen Curry",
        team: "GSW",
        number: 30,
        position: "G",
        height: "6-2",
        weight: 185,
        lastAttended: "Davidson",
        country: "USA",
      },
      {
        player: "Lebron James",
        team: "LAL",
        number: 6,
        position: "F",
        height: "6-9",
        weight: 250,
        lastAttended: "St. Vincent-St. Mary HS (OH)",
        country: "USA",
      },
      {
        player: "Kevin Durant",
        team: "BKN",
        number: 7,
        position: "F",
        height: "6-10",
        weight: 240,
        lastAttended: "Texas-Austin",
        country: "USA",
      },
      {
        player: "Giannis Antetokounmpo",
        team: "MIL",
        number: 34,
        position: "F",
        height: "6-11",
        weight: 242,
        lastAttended: "Filathlitikos",
        country: "Greece",
      },
    ];
    const headers = [
      { text: "PLAYER", value: "player" },
      { text: "TEAM", value: "team" },
      { text: "NUMBER", value: "number" },
      { text: "POSITION", value: "position" },
      { text: "HEIGHT", value: "height" },
      { text: "WEIGHT (lbs)", value: "weight", sortable: true },
      { text: "LAST ATTENDED", value: "lastAttended" },
      { text: "COUNTRY", value: "country" },
    ];

    const items = [
      {
        player: "MED4567",
        team: "30049099",
        number: "Dolo 650 Tab 10’s",
        position: "149.90",
        height: "12%",
        weight: 121.54,
        lastAttended: "121.54",
      },
      {
        player: "MED4567",
        team: "30049099",
        number: "Dolo 650 Tab 10’s",
        position: "149.90",
        height: "12%",
        weight: 121.54,
        lastAttended: "121.54",
      },
      {
        player: "MED4567",
        team: "30049099",
        number: "Dolo 650 Tab 10’s",
        position: "149.90",
        height: "12%",
        weight: 121.54,
        lastAttended: "121.54",
      },
      {
        player: "MED4567",
        team: "30049099",
        number: "Dolo 650 Tab 10’s",
        position: "149.90",
        height: "12%",
        weight: 121.54,
        lastAttended: "121.54",
      },
    ];
    const sidebardata = [
      {
        id: "SUP9856",
        store: "MS",
        storename: "MainStore Supplies",
      },
      {
        id: "SUP9856",
        store: "SS",
        storename: "MainStore Supplies",
      },
      {
        id: "SUP9856",
        store: "DS",
        storename: "MainStore Supplies",
      },
      {
        id: "SUP9856",
        store: "MS",
        storename: "MainStore Supplies",
      },
      {
        id: "SUP9856",
        store: "MS",
        storename: "MainStore Supplies",
      },
      {
        id: "SUP9856",
        store: "MS",
        storename: "MainStore Supplies",
      },
      {
        id: "SUP9856",
        store: "MS",
        storename: "MainStore Supplies",
      },
      {
        id: "SUP9856",
        store: "MS",
        storename: "MainStore Supplies",
      },
      {
        id: "SUP9856",
        store: "MS",
        storename: "MainStore Supplies",
      },
    ];
    const showmodalref = ref(false);
    const handleClick = () => {
      showmodalref.value = true;
      // alert(showmodalref.value)
    };
    return {
      handleClick,
      showpopModal: showmodalref,
      sidebardata,
      iheader,
      userheader,
      Icategoryheader,
      docheader,
      Iitems,
      headers,
      items,
    };
  },
});
</script>

<style lang="scss" scoped>
.col-xl-2 {
  width: 19.666667%;
}

.col-xl-10 {
  width: 80.333333%;
}

.sidebar-static-header {
  padding: 15px 15px 20px 45px;
  font-weight: 600;
  border-bottom: 5px solid #f8f9fe;
  position: sticky;
  left: 0px;
  top: 0px;
  background-color: #f8f9fe;
  z-index: 1;
}

.other-tabs {
  height: 90vh;
  padding-left: 5px !important;
  overflow: auto;
}

.overall-bg {
  section {
    width: 100%;
    overflow: hidden;
  }
}

.leftsidebar {
  position: relative;
  padding-right: 0px !important;
}

.n-tabs .n-tabs-nav {
  position: sticky;
  box-sizing: border-box;
  line-height: 1.5;
  display: flex;
  transition: border-color 0.3s var(--n-bezier);
  top: 80px;
  left: 0px;
  background: antiquewhite;
}

.n-tabs-nav--line-type .n-tabs-nav--top .n-tabs-nav {
  position: sticky;
  top: 80px;
  left: 0px;
  background-color: #999999;
}

.back-btn {
  background-color: #0148e2;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  position: absolute;
  top: 20px;
  right: -20px;
  z-index: 1000;

  .back {
    width: 20px;
    position: absolute;
    top: -45px;
    left: 8px;
    // filter: invert(100%) sepia(2%) saturate(0%) hue-rotate(141deg) brightness(98%) contrast(108%);
  }
}

.count-shows {
  font-weight: 300;
  padding-bottom: 10px;
}

.n-tabs.n-tabs--line-type .n-tabs-tab.n-tabs-tab--active,
.n-tabs.n-tabs--bar-type .n-tabs-tab.n-tabs-tab--active {
  color: #000000;
  font-weight: var(--n-tab-font-weight-active);
}

.n-tabs .n-tabs-tab {
  --n-bar-color: #999999;
  cursor: pointer;
  white-space: nowrap;
  flex-wrap: nowrap;
  display: inline-flex;
  align-items: left;
  color: #999999;
  font-size: var(--n-tab-font-size);
  background-clip: padding-box;
  padding: var(--n-tab-padding);
  transition: box-shadow 0.3s var(--n-bezier), color 0.3s var(--n-bezier),
    background-color 0.3s var(--n-bezier), border-color 0.3s var(--n-bezier);
}
</style>
